import { InfoPrivacyFormValues } from 'components/Privacy/Privacy.types';
import {
  makeSelectAuthApiConfig,
  makeSelectResourceLoadingState,
} from 'services/api/api.selectors';
import { RequestApiDataIfNecessaryPayload } from 'services/api/api.types';
import {
  getInfoPrivacyEndpoint,
  setInfoPrivacyEndpoint,
} from 'services/privacy/privacy.config';
import {
  InfoPrivacyFormStateConfig,
  postContextSensitiveInfoPrivacyRequestData,
} from 'services/privacy/privacy.helpers';
import {
  getInfoPrivacyResponseSchema,
  InfoPrivacy,
} from 'services/privacy/privacy.types';
import { AppState, ReduxSelector } from 'store/types';

export function makeSelectCreateSubmitInfoPrivacyApiConfig({
  formValues,
}: {
  formValues: InfoPrivacyFormValues;
}): ReduxSelector<RequestApiDataIfNecessaryPayload> {
  return function selectSubmitInfoPrivacyApiConfig(
    reduxState: AppState,
  ): RequestApiDataIfNecessaryPayload {
    const InfoPrivacyStateConfig = {
      formValues,
    } as InfoPrivacyFormStateConfig;

    const contextSensitivePayloadData =
      postContextSensitiveInfoPrivacyRequestData(
        InfoPrivacyStateConfig as Required<InfoPrivacyFormStateConfig>,
      );

    const requestConfig = makeSelectAuthApiConfig({
      url: setInfoPrivacyEndpoint,
      method: 'POST',
      data: contextSensitivePayloadData,
    })(reduxState);

    return {
      resourceId: setInfoPrivacyEndpoint,
      requestConfig,
      skipDefaultServerErrorHandling: true,
    };
  };
}

export const selectGetInfoPrivacyEndpointApiConfig: ReduxSelector<
  RequestApiDataIfNecessaryPayload
> = (reduxState: AppState) => {
  return {
    resourceId: getInfoPrivacyEndpoint,
    requestConfig: makeSelectAuthApiConfig({
      url: getInfoPrivacyEndpoint,
      method: 'GET',
    })(reduxState),
    successSchemaValidator: getInfoPrivacyResponseSchema,
  };
};

export const selectPrivacyState = (reduxState: AppState) => reduxState.privacy;

export const selectInfoPrivacy: ReduxSelector<InfoPrivacy[]> = (
  reduxState: AppState,
) => selectPrivacyState(reduxState).infoPrivacy;

export const selectInfoPrivacyLoadState = makeSelectResourceLoadingState(
  getInfoPrivacyEndpoint,
);
